"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        ignore: true,
        key: 'mask',
    },
    {
        key: 'inputMask',
        ignore: true
    },
    {
        key: 'allowMultipleMasks',
        ignore: true
    }
];
